/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Link_DescriptionInputs */

const fr_guardian_link_description = /** @type {(inputs: Guardian_Link_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour un enfant déjà suivi par un autre parent.`)
};

/**

* @param {Guardian_Link_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_link_description = /** @type {((inputs?: Guardian_Link_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Link_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_link_description(inputs)
});